<div class="card prospeccion-modal">
  <header class="card-header card-header-primary prospeccion-modal__header">
    <div class="prospeccion-modal__header-copy">
      <h4 class="card-title"><b>{{ titulo }}</b></h4>
      <p class="card-category" *ngIf="agregarProspecto">
        Registra el cliente prospecto y la descripción inicial de la oportunidad.
      </p>
      <p class="card-category" *ngIf="!agregarProspecto">
        Consulta el prospecto y registra el seguimiento de sus compromisos.
      </p>
    </div>
    <button mat-icon-button type="button" class="prospeccion-modal__close" aria-label="Cerrar" (click)="onNoClick()">
      <mat-icon>clear</mat-icon>
    </button>
  </header>

  <div class="card-body prospeccion-modal__body">
    <div class="prospeccion-modal__content">
      <form *ngIf="agregarProspecto" [formGroup]="datosformProspecto" class="prospeccion-modal__form">
        <section class="prospeccion-modal__fields">
          <mat-form-field>
            <mat-label>Cliente prospecto</mat-label>
            <mat-select formControlName="cliente" required>
              <mat-option *ngFor="let cliente of clientes" [value]="cliente.id">
                {{ cliente.razonsocial }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="prospeccion-modal__field--full">
            <mat-label>Descripción</mat-label>
            <textarea matInput aria-label="Descripción" rows="5" maxlength="150" formControlName="descripcion"></textarea>
          </mat-form-field>
        </section>

        <footer class="prospeccion-modal__actions">
          <button mat-button type="button" class="btn btn-danger" (click)="onNoClick()">
            <i class="fa fa-times-circle-o"></i> Cancelar
          </button>
          <button mat-button type="button" class="btn btn-success" [disabled]="datosformProspecto.invalid"
            (click)="guardaProspecto()">
            Guardar <i class="material-icons">save</i>
          </button>
        </footer>
      </form>

      <section *ngIf="!agregarProspecto" class="prospeccion-modal__detail">
        <div class="prospeccion-modal__summary">
          <span>Razón social</span>
          <strong>{{ data.item.razonsocial }}</strong>
        </div>

        <div class="prospeccion-modal__detail-grid">
          <div><span>Forma de contacto</span><strong>{{ data.item.formacontacto || '-' }}</strong></div>
          <div><span>Nombre de contacto</span><strong>{{ data.item.nombreContacto || '-' }}</strong></div>
          <div><span>Correo</span><strong>{{ data.item.email || '-' }}</strong></div>
          <div><span>Teléfono</span><strong>{{ data.item.telefono || '-' }} <ng-container *ngIf="data.item.extensionTel">Ext. {{ data.item.extensionTel }}</ng-container></strong></div>
          <div><span>Tipo de cliente</span><strong>{{ data.item.tipo || '-' }}</strong></div>
          <div><span>Segmento</span><strong>{{ data.item.segmento || '-' }}</strong></div>
          <div><span>Tamaño</span><strong>De {{ data.item.de || '-' }} a {{ data.item.al || '-' }}</strong></div>
        </div>

        <div class="prospeccion-modal__description">
          <span>Descripción</span>
          <p>{{ data.item.descripcion || 'Sin descripción registrada.' }}</p>
        </div>

        <div class="prospeccion-modal__actions prospeccion-modal__actions--detail">
          <button mat-button type="button" class="btn btn-success" (click)="registroSeguimientoBtn()">
            Agregar seguimiento <i class="material-icons">add</i>
          </button>
        </div>
      </section>

      <section *ngIf="registroSeguimiento" class="prospeccion-modal__section">
        <h5>Registrar seguimiento</h5>
        <form [formGroup]="datosformRegisroSeguimiento" class="prospeccion-modal__form">
          <div class="prospeccion-modal__fields">
            <mat-form-field>
              <mat-label>Actividad</mat-label>
              <textarea matInput aria-label="Actividad" rows="3" maxlength="500" [(ngModel)]="objetoSeguimiento.actividad" formControlName="actividad"></textarea>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Compromiso</mat-label>
              <input matInput aria-label="Compromiso" maxlength="500" [(ngModel)]="objetoSeguimiento.compromiso" formControlName="compromiso">
            </mat-form-field>

            <mat-form-field>
              <mat-label>Fecha del compromiso</mat-label>
              <input matInput aria-label="Fecha del compromiso" formControlName="fechaSigSeguimiento" [(ngModel)]="objetoSeguimiento.fechaSigSeguimiento"
                [matDatepicker]="fechaSigSeguimiento" readonly>
              <mat-datepicker-toggle matSuffix [for]="fechaSigSeguimiento"></mat-datepicker-toggle>
              <mat-datepicker #fechaSigSeguimiento></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Nota</mat-label>
              <textarea matInput aria-label="Nota" rows="3" maxlength="500" [(ngModel)]="objetoSeguimiento.nota" formControlName="nota"></textarea>
            </mat-form-field>

            <div class="prospeccion-modal__radio-group">
              <span>¿Se cumplió el compromiso?</span>
              <mat-radio-group [(ngModel)]="objetoSeguimiento.estatus" name="estatus" formControlName="estatus"
                (change)="onRadioCompromisoChange()">
                <mat-radio-button [value]="1">Sí</mat-radio-button>
                <mat-radio-button [value]="0">No</mat-radio-button>
              </mat-radio-group>
            </div>

            <mat-form-field>
              <mat-label>Observaciones</mat-label>
              <textarea matInput aria-label="Observaciones" rows="3" maxlength="500" [(ngModel)]="objetoSeguimiento.observaciones" formControlName="observaciones"></textarea>
            </mat-form-field>
          </div>

          <footer class="prospeccion-modal__actions">
            <button mat-button type="button" class="btn btn-danger" (click)="cancelarRegistroSeguimieto()">
              <i class="fa fa-times-circle-o"></i> Cancelar
            </button>
            <button mat-button type="button" class="btn btn-success" [disabled]="datosformRegisroSeguimiento.invalid" (click)="save()">
              Guardar <i class="material-icons">save</i>
            </button>
          </footer>
        </form>
      </section>

      <section *ngIf="!agregarProspecto && seguimientosLista?.length" class="prospeccion-modal__section">
        <div class="prospeccion-modal__section-heading">
          <h5>Seguimientos registrados</h5>
          <button mat-button type="button" class="btn btn-info" (click)="toggleMostrarRecientes()">
            {{ mostrarRecientes ? 'Mostrar todos' : 'Mostrar reciente' }}
          </button>
        </div>

        <article *ngFor="let seguimiento of getseguimientosAMostrar(); let i = index" class="prospeccion-modal__follow-up">
          <div>
            <strong>{{ i + 1 }}. {{ seguimiento.fechaSigSeguimiento | date: 'dd/MM/yyyy' }}</strong>
            <span>{{ seguimiento.actividad }} · Responsable: {{ seguimiento.responsable || '-' }}</span>
          </div>
          <button mat-icon-button type="button" aria-label="Editar seguimiento" (click)="editarSeguimiento(seguimiento.id_seguimiento)">
            <mat-icon>edit</mat-icon>
          </button>
        </article>
      </section>
    </div>
  </div>
</div>
